import styled from 'styled-components';
import tw from 'twin.macro';

import { ImageIcon } from '../../icons/ImageIcon';

export const UploadedImage = styled.img`
  ${tw`mb-4 w-[100px] h-[64px]`}
`;
export const MainContainer = styled.div`
  ${tw`flex items-center justify-between px-4 py-2 bg-white rounded-8px border-dashed border-[1px] border-blue-gray-300`};
`;
export const FileNameContainer = styled.div`
  ${tw`flex items-center`}
`;
export const UploadedImageIcon = styled(ImageIcon)`
  ${tw`mr-2`}
`;
export const FileNameText = styled.span`
  ${tw`text-14px font-medium text-blue-gray-700 w-200px whitespace-nowrap overflow-hidden font-inter overflow-ellipsis`}
`;
export const DeleteButton = styled.button`
  ${(props) =>
    props.isDisabled ? tw`cursor-auto select-none` : tw`cursor-pointer`}
`;

export const Retry = styled.span`
  ${tw`text-red-600 font-medium text-14px`}
`;
